import { useSettings } from '@wu/widget-core';

export function useWillFormServiceBeRegistered() {
  const { blocks = [] } = useSettings();

  return blocks.some(({ type }) => type === 'form');
}
